// 取两位小数
const toFixedNumber = value => {
    if (!isNaN(value) && value) {
        return value.toFixed(2);
    }
    return 0;
};
// 负数转正数
const absNum = value => {
    if (!isNaN(value) && value) {
        value = Math.abs(value);
        return value;
    }
    return 0;
};
// 百分比*100
const num100 = value => {
    if (!isNaN(value) && value) {
        value = value * 100;
        return value;
    }
    return 0;
};
const currencyStyle = (value, style) => { //  货币格式
    /**
     * style: 
     *      currency：货币
     *      number： 数字格式
     */

    if (!value) {
        return 0;
    }
    if (style === 'number') { // 数字格式
        // eslint-disable-next-line no-useless-escape
        return parseFloat(value.replace(/[^\d\.-]/g, ''));
        // eslint-disable-next-line no-else-return
    } else {
        // 货币格式, 并保留2位小数
        const n = 2;
        // eslint-disable-next-line no-useless-escape
        value = parseFloat((value + '').replace(/[^\d\.-]/g, '')).toFixed(n) + '';
        const l = value.split('.')[0].split('').reverse();
        const r = value.split('.')[1];
        let t = '';
        for (let i = 0; i < l.length; i++) {
            t += l[i] + ((i + 1) % 3 === 0 && i + 1 !== l.length ? ',' : '');
        }
        return t.split('').reverse().join('') + '.' + r;
    }
};
const toStar = value => {
    let str = '';
    if (value) {
        value = value + '';
        for (let i = 0; i < value.length; i++) {
            str += '*';
        }
    }
    return str;
};
export {
    currencyStyle,
    toFixedNumber,
    absNum,
    num100,
    toStar,
};